export type Procedure = (...args: Array<any>) => void;

export const debounce = (
  fn: Procedure,
  ms = 0,
  { leading = false, trailing = true } = {},
): Procedure => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  return function (this: any, ...args: Array<any>) {
    if (leading && timeoutId === null) {
      fn.apply(this, args);
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    if (!trailing || !leading || timeoutId) {
      timeoutId = setTimeout(() => {
        if (trailing) {
          fn.apply(this, args);
        }
        timeoutId = null;
      }, ms);
    } else {
      // Special case for a single call with both leading and trailing (see tests)
      timeoutId = setTimeout(() => {
        timeoutId = null;
      }, ms);
    }
  };
};
